import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated, loading, isAdmin } = useUser();
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const checkAuthorization = () => {
      // console.log('🔒 ProtectedRoute: Checking authorization...');
      // console.log('📊 ProtectedRoute Debug:');
      // console.log('  - loading:', loading);
      // console.log('  - isAuthenticated:', isAuthenticated);
      // console.log('  - user:', user);
      // console.log('  - requireAdmin:', requireAdmin);
      // console.log('  - localStorage.userData:', localStorage.getItem('userData'));

      // Still loading user data
      if (loading) {
        // console.log('⏳ ProtectedRoute: Still loading, waiting...');
        return;
      }

      // Not authenticated at all
      if (!isAuthenticated || !user) {
        // console.log('❌ ProtectedRoute: User not authenticated, redirecting to login');
        // console.log('  - isAuthenticated:', isAuthenticated);
        // console.log('  - user:', user);
        navigate('/', { replace: true });
        return;
      }

      // Requires admin but user is not admin
      if (requireAdmin && !isAdmin()) {
        // console.log('🚫 ProtectedRoute: Admin required but user is not admin, redirecting to login');
        alert('Access denied. Admin privileges required.');
        navigate('/', { replace: true });
        return;
      }

      // User is authorized
      // console.log('✅ ProtectedRoute: User authorized, rendering protected content');
      setIsAuthorized(true);
    };

    checkAuthorization();
  }, [isAuthenticated, user, loading, requireAdmin, navigate, isAdmin]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}></div>
        <div style={styles.loadingText}>Verifying access...</div>
      </div>
    );
  }

  // Only render children if user is authorized
  if (isAuthorized) {
    return children;
  }

  // Show nothing while redirecting
  return null;
};

const styles = {
  loadingContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
    zIndex: 9999,
  },
  spinner: {
    width: 40,
    height: 40,
    border: '4px solid #e3e3e3',
    borderTop: '4px solid #3498db',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#666',
    fontWeight: '500',
  },
};

// Add CSS animation for spinner
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
if (!document.querySelector('style[data-protected-route]')) {
  styleSheet.setAttribute('data-protected-route', 'true');
  document.head.appendChild(styleSheet);
}

export default ProtectedRoute;